import * as Sentry from '@sentry/react';
import { Utils as utils } from '@client/utility';

interface ApiError {
  __api: boolean;
  statusCode: number;
  timestamp: string;
  requestId: string;
  error: string;
  path: string;
  method: string;
}

interface ApiSuccess {
  message: string;
  user: { id: string; email: string };
  session: { access_token: string; expires_at: number };
}

function isApiError(response: any): response is ApiError {
  return response && response.__api === true && typeof response.error === 'string';
}

function isApiSuccess(response: any): response is ApiSuccess {
  return response && typeof response.message === 'string' && response.user && response.session;
}

export const handleLogin = async (
  email: string,
  password: string,
  captchaToken: string
): Promise<{ success: true; data: ApiSuccess }> => {
  const response = await utils.post<ApiSuccess | ApiError>('/api/Login', {
    email,
    password,
    captchaToken,
  });

  if (isApiError(response)) {
    throw response;
  }

  if (!isApiSuccess(response)) {
    throw new Error('Invalid response from server');
  }

  return { success: true, data: response };
};

export const handleOAuthSignIn = async (provider: 'google' | 'discord') => {
  const { error } = await utils.db.client.auth.signInWithOAuth({ provider });
  if (error) throw error;
  return { success: true };
};

export const handleSignUp = async (
  email: string,
  password: string,
  captchaToken: string,
  username?: string
): Promise<{ success: true; data: ApiSuccess }> => {
  const response = await utils.post<ApiSuccess | ApiError>('/api/Register', {
    email,
    password,
    username,
    captchaToken,
  });

  if (isApiError(response)) {
    throw response;
  }

  if (!isApiSuccess(response)) {
    throw new Error('Invalid response from server');
  }

  return { success: true, data: response };
};